import { Injectable, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  public defaultLanguage: EventEmitter<string> = new EventEmitter();

  constructor(private translateService: TranslateService) { }

  getVariable(variableName: string, type?: TypeStorage) {
    const typeStorage = type === 'session' ? sessionStorage : localStorage;
    return typeStorage.getItem(variableName);
  }

  persistInBrowser(key: string, value: string, type?: TypeStorage) {
    const typeStorage = type === 'session' ? sessionStorage : localStorage;
    typeStorage.setItem(key, value);
  }

  getMonthsList() {
    const lang = this.translateService.currentLang;

    if (lang  === 'fr') {
      return ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    } else if (lang === 'en') {
      return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    } else if (lang === 'es') {
      return ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    } else if (lang === 'de') {
      return ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    }
    return [];
  }
  /**
   * Escapes special XML/HTML characters in a string by converting them to their corresponding entities.
   *
   * @param input - The input string to be escaped.
   * @returns The escaped string with special characters converted to HTML entities.
   */
  escapeXmlCharacters(input: string): string {
    if (!input) return input;
    const div = document.createElement('div');
    div.innerText = input;
    return div.innerHTML;
  }
}

declare interface CustomKeycloakProfile extends Keycloak.KeycloakProfile {
  attributes: {locale: string[]};
}

declare type TypeStorage = 'session' | 'local';
